
<template>
  <div class="cores">
    <template>
      <v-card v-if="dataReady">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex" cols="2" sm="6">
              <v-select
                :items="versions"
                @change="changedCoreVersion(selectedCoreVersion)"
                v-model="selectedCoreVersion"
                label="Select Version"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
        <v-data-table
          :headers="headers"
          :items="cores"
          :items-per-page="10"
          class="elevation-2"
          loading-text="Loading... Please wait"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.coreName }}</td>
            <td>
              <v-btn color="info" dark @click="editItem(props)">
                <font-awesome-icon icon="edit" class="pr-1" />Edit
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <v-dialog
      v-if="userWritePrivileges"
      v-model="dialog"
      persistent
      max-width="500px"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark class="mb-2" v-on="on"
          >Create New Core</v-btn
        >
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Create New Core</span>
        </v-card-title>
        <v-card-text v-if="errors.length > 0" class="red--text">
          Errors:
          <ul id="errorsList">
            <li v-for="error in errors" :key="error">
              {{ error }}
            </li>
          </ul>
        </v-card-text>
        <v-card-text>
          <Input
            v-model="jsonString"
            type="textarea"
            :autosize="true"
            placeholder="Paste correctly formatted JSON here"
          ></Input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="create">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import RequestService from '@/RequestService';
import MulesoftCoreService from '@/MulesoftCoreService';

@Component
export default class MulesoftTable extends Vue {
  /*eslint-disable */
  data() {
    return {
      dataReady: false,
      dialog: false,
      jsonString: "",
      jsonData: {},
      errors: [],
      cores: [],
      versions: [],
      userWritePrivileges: false,
    };
  }
  /* eslint-enable */

  headers = [
    {
      text: 'Core Name',
      value: 'item',
      sortable: true,
      align: 'left',
    },
    { text: 'Actions', value: 'action', sortable: false },
  ];

  editItem(item) {
    this.$emit('coreName', item.item);
  }

  close() {
    this.dialog = false;
    setTimeout(() => {
      this.errors = [];
      this.jsonData = {};
      this.jsonString = '';
    }, 300);
  }

  async create() {
    this.errors = [];

    try {
      this.jsonData = JSON.parse(this.jsonString);
      const validationErrors = MulesoftCoreService.validateCoreJson(
        this.jsonData,
        this.cores,
      );
      if (validationErrors.length > 0) {
        validationErrors.forEach((element) => {
          this.errors.push(element);
        });
      }
    } catch (e) {
      this.errors.push('Invalid JSON!');
    }

    if (this.errors.length === 0) {
      if (
        window.confirm(
          `Are you sure you want to create new core:\n ${JSON.stringify(
            this.jsonData,
          )}`,
        )
      ) {
        await MulesoftCoreService.updateMulesoftCore(this.jsonData);
        this.jsonData = {};
        this.jsonString = '';
        this.dialog = false;
        this.errors = [];
        this.cores = await MulesoftCoreService.getAllMulesoftCores();
      }
    }
  }

  async changedCoreVersion(selectedCoreVersion) {
    this.cores = [];
    this.cores = await MulesoftCoreService.getMulesoftCoresByVersion(selectedCoreVersion);
  }

  async mounted() {
    this.cores = await MulesoftCoreService.getAllMulesoftCores();
    this.versions = await MulesoftCoreService.getAllMulesoftCoreVersions();
    this.dataReady = true;
    this.userWritePrivileges = await RequestService.checkCredentials();
  }
}
</script>
